// src/utils/animations.js
/** @jsxImportSource @emotion/react */
import { keyframes } from "@emotion/react";

export const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.5); }
  to { opacity: 1; transform: scale(1); }
`;
